import React from "react";

import Container from "@mui/material/Container";

import DataTable from "./DataTable";
import CommonLayout from "../../Common/Layout";

const AuditReport = () => {
  const breadcrumbArr = [
    { link: "/reports", displayName: "Reports", active: false },
    { link: "#", displayName: "Audit History", active: true },
  ];

  return (
    <CommonLayout title="Audit History" breadcrumbArr={breadcrumbArr}>
      <Container maxWidth="false" sx={{ m: 0, overflowY: "auto", maxHeight: "100%" }}>
        <DataTable />
      </Container>
    </CommonLayout>
  );
};

export default AuditReport;
